/** In this file exist the HOC called for every CRUD */
import React from "react";

/** These imports are important to get the entities from every ModuleDefinitions */
import emailTemplateConfig from "../EmailTemplate/ModuleDefinition";
import filterConfig from "../Filter/ModuleDefinition";
import legalInfoConfig from "../LegalInfo/ModuleDefinition";
import displayConfig from "../Display/ModuleDefinition";
import modificationConfig from "../Modification/ModuleDefinition";
import paymentTypesConfig from "../PaymentTypes/ModuleDefinition";
import cancellationPolicyConfig from "../CancellationPolicy/ModuleDefinition";
import cancellationPolicyConfigurationConfig from "../CancellationPolicy/CancellationPolicyConfiguration/ModuleDefinition";
import QuestionnaireConfig from "../Questionnaire/ModuleDefinition";
import NestedQuestionnaireConfig from "../Questionnaire/NestedQuestionnaires/ModuleDefinition";
import NestedFilterOption from "../Filter/FilterOption/ModuleDefinition";
import conditionsConfig from "../Conditions/ModuleDefinition";
import configurationManagerConfig from "../../ConfigurationManager/ModuleDefinition";
import promotionsConfig from "../Promotions/ModuleDefinition";
import promotionsBookingwindowConfig from "../Promotions/PromotionsBookingWindow/ModuleDefinition";
import promotionsTravelWindowConfig from "../Promotions/PromotionsTravelWindow/ModuleDefinition";
import promotionsCloseTravelWindowConfig from "../Promotions/PromotionsCloseTravelWindow/ModuleDefinition";
import promotionsCloseBookingWindowConfig from "../Promotions/PromotionsCloseBookingWindow/ModuleDefinition";
import modificationBookingWindowConfig from "../Modification/ModificationBookingWindow/ModuleDefinition";
import forwardingReservationsConfig from "../../ForwardingReservations/ModuleDefinition";
import clientsConfig from "../CRM/Clients/ModuleDefinition";
import contractsConfig from "../CRM/Contracts/ModuleDefinition";
import partnersConfig from "../CRM/Partners/ModuleDefinition";
import propertiesConfig from "../CRM/Properties/ModuleDefinition";
import servicesConfig from "../CRM/Services/ModuleDefinition";
import CONSTANTS from "../constants";

/** Here the constants are disglosed using the ModuleDefinition and the ModuleTranslations if it's being used */
const getGlobalEntityConfiguration = ({ locale }) => ({
  [CONSTANTS.ENTITY.EMAIL_TEMPLATE.name]: emailTemplateConfig({ locale }),
  [filterConfig.entityName]: filterConfig,
  [cancellationPolicyConfig.entityName]: cancellationPolicyConfig,
  [CONSTANTS.ENTITY.LEGAL_INFO.name]: legalInfoConfig({ locale }),
  [CONSTANTS.ENTITY.DISPLAY.name]: displayConfig({ locale }),
  [CONSTANTS.ENTITY.MODIFICATION.name]: modificationConfig({ locale }),
  [CONSTANTS.ENTITY.PAYMENT_TYPES.name]: paymentTypesConfig({ locale }),
  //
  [CONSTANTS.ENTITY.CANCELLATIONPOLICY.name]: cancellationPolicyConfig({
    locale,
  }),
  [CONSTANTS.ENTITY.CANCELLATIONPOLICYCONFIGURATION.name]: cancellationPolicyConfigurationConfig({
    locale,
  }),
  [CONSTANTS.ENTITY.QUESTIONNAIRE.name]: QuestionnaireConfig({ locale }),
  [CONSTANTS.ENTITY.NESTEDFILTER.name]: NestedFilterOption,
  [CONSTANTS.ENTITY.NESTEDQUESTIONNAIRE.name]: NestedQuestionnaireConfig({
    locale,
  }),
  [CONSTANTS.ENTITY.CONDITIONS.name]: conditionsConfig({ locale }),
  [CONSTANTS.ENTITY.CONFIGURATION_MANAGER.name]: configurationManagerConfig({
    locale,
  }),
  [CONSTANTS.ENTITY.PROMOTIONS.name]: promotionsConfig({ locale }),
  [CONSTANTS.ENTITY.PROMOTIONSBOOKINGWINDOW.name]: promotionsBookingwindowConfig({
    locale,
  }),
  [CONSTANTS.ENTITY.PROMOTIONSTRAVEL.name]: promotionsTravelWindowConfig({
    locale,
  }),
  [CONSTANTS.ENTITY.PROMOTIONSCLOSETRAVELWINDOW.name]: promotionsCloseTravelWindowConfig({
    locale,
  }),
  [CONSTANTS.ENTITY.MODIFICATIONBOOKINGWINDOW.name]: modificationBookingWindowConfig({
    locale,
  }),
  [CONSTANTS.ENTITY.PROMOTIONSCLOSEBOOKINGWINDOW.name]: promotionsCloseBookingWindowConfig({
    locale,
  }),
  // [CONSTANTS.ENTITY.BOOKABLE.name]: bookableConfig({ locale }),
  [CONSTANTS.ENTITY.CLIENTS.name]: clientsConfig({ locale }),
  [CONSTANTS.ENTITY.CONTRACTS.name]: contractsConfig({ locale }),
  [CONSTANTS.ENTITY.PARTNERS.name]: partnersConfig({ locale }),
  [CONSTANTS.ENTITY.PROPERTIES.name]: propertiesConfig({ locale }),
  [CONSTANTS.ENTITY.SERVICES.name]: servicesConfig({ locale }),
  [CONSTANTS.ENTITY.FORWARDING_RESERVATIONS.name]: forwardingReservationsConfig({ locale }),
});

/** This is the HOC used to give the constants*/
function asBookingEngineEntity(WrappedComponent, { type, entityName, section }) {
  return class extends React.Component {
    constructor(props, context) {
      super(props, context);
      const { hotelTicker = "demo_devs", id = null, locales = ["es", "en"] } = this.props;

      const locale = props.locale;
      const globalEntityConfiguration = getGlobalEntityConfiguration({
        locale,
      });
      if (!globalEntityConfiguration.hasOwnProperty(entityName)) {
        throw new Error(`Erroneous Entity ${entityName}`);
      }
      //TODO: What if the language changes in runtime? must implement the ComponentWillReceiveProps and update config
      //TODO: Internationalize ALL Entity config
      const config = globalEntityConfiguration[entityName];
      this.state = {
        hotelTicker,
        locales,
        locale,
        id,
        globalEntityConfiguration,
        config,
        entityName,
        type,
      };
    }

    componentDidUpdate(prevProps) {
      const locale = this.props.locale;
      if (prevProps.locale !== locale) {
        const globalEntityConfiguration = getGlobalEntityConfiguration({
          locale,
        });
        if (!globalEntityConfiguration.hasOwnProperty(entityName)) {
          throw new Error(`Erroneous Entity ${entityName}`);
        }
        const config = globalEntityConfiguration[entityName];
        this.setState({
          globalEntityConfiguration,
          config,
        });
      }
    }

    render() {
      const { locales, hotelTicker, id, globalEntityConfiguration, config } = this.state;
      const { history, ...otherProps } = this.props;

      return (
        <div>
          <WrappedComponent
            locales={locales}
            hotelTicker={hotelTicker}
            id={id}
            history={history}
            globalEntityConfiguration={globalEntityConfiguration}
            config={config}
            entityName={entityName}
            type={type}
            section={section}
            {...otherProps}
          />
        </div>
      );
    }
  };
}

export default asBookingEngineEntity;
